export const callTestSelectors = {
  draftIcon: 'call-draft-icon'
};
